<template lang="pug">
.input-text-field-horizontal(ref='inputField')
  .input-text-field-horizontal__text-before(v-if='beforeText') {{ beforeText }}
  text-field-study.input-text-field-horizontal__input(v-model='inputValue', :maxWidth='maxWidth')
  .input-text-field-horizontal__text-after(v-if='afterText') {{ afterText }}
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import TextFieldStudy from '@/components/molecules/student/TextFieldStudy.vue'

/**
 * テキスト入力形式（横書き）
 */
@Component({
  components: {
    TextFieldStudy,
  },
})
export default class InputTextFieldHorizontal extends Vue {
  // 入力欄の最大幅
  private maxWidth = 0

  // 入力値
  @Prop()
  value!: string

  // 前方テキスト
  @Prop()
  beforeText?: string

  // 後方テキスト
  @Prop()
  afterText?: string

  // テキスト入力要素Ref
  @Ref() inputField!: HTMLElement

  // 入力値ゲッター・セッター
  get inputValue(): string {
    return this.value
  }
  set inputValue(value: string) {
    this.$emit('input', value)
  }

  // 要素の幅を入力欄の最大幅に設定
  private mounted() {
    this.maxWidth = this.inputField.clientWidth
  }
}
</script>

<style lang="stylus" scoped>
.input-text-field-horizontal
  display flex
  align-items center
  flex-direction row
  flex-wrap wrap
  justify-content flex-start

  &__text-before
    margin-right 10px

  &__input
    border-radius 4px
    margin-right 10px
</style>
